import { createAction, createReducer } from 'redux-act'

const GOOGLE_API_SRC = 'https://apis.google.com/js/api:client.js';

export const REDUCER = 'google_sign_in';
const NS = `@@${REDUCER}/`;

export const startedLoading = createAction(`${NS}START_LOADING`);
export const doneLoading = createAction(`${NS}DONE_LOADING`);

const initialState = {
  isLoading: false,
};

export const initButton = ({ buttonId, onSignInSuccess, onSignInFailure, clientId, scope }) => (dispatch) => {
  dispatch(startedLoading());
  const script = document.createElement('script');
  script.src = GOOGLE_API_SRC;
  script.onload = () => {
    window.gapi.load('auth2', () => {

      const auth2 = window.gapi.auth2
        .init({
          client_id: clientId,
          cookiepolicy: 'single_host_origin',
          scope: scope,
        });

      auth2.attachClickHandler(document.getElementById(buttonId), {}, onSignInSuccess, onSignInFailure);

      dispatch(doneLoading());
    });
  };
  document.head.appendChild(script);
};

export default createReducer(
  {
    [startedLoading]: (state) => ({ ...state, isLoading : true }),
    [doneLoading]: (state) => ({ ...state, isLoading : false }),
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/sign_in/google.js